module.exports = __webpack_public_path__ + "img/incomplete.e0bd4294.svg";